var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstallersIconGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 13,
    viewBox: "0 0 18 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.762 0C11.0343 0.1506 11.2337 0.306612 11.2331 0.649295L10.6096 6.4689C10.7367 7.12691 11.6537 7.19184 11.8272 6.52391C12.065 4.95147 12.1245 3.31862 12.3614 1.75099C12.3671 1.71312 12.3481 1.66382 12.4183 1.69207C12.5978 1.76452 13.0656 2.14147 13.2368 2.28275C15.0017 3.74036 16.1012 6.05798 16.222 8.35907C16.2339 8.58692 16.2566 9.14513 16.2205 9.34443C16.2125 9.38862 16.2006 9.41808 16.1622 9.44273H1.30649C1.2678 9.41808 1.25589 9.38832 1.24816 9.34443C1.21184 9.14453 1.23476 8.58812 1.24667 8.35907C1.38328 5.69065 2.80447 3.10639 5.05041 1.69207C5.13285 1.68125 5.09952 1.69839 5.10725 1.75099C5.34447 3.31862 5.4037 4.95177 5.6415 6.52391C5.81502 7.19184 6.73203 7.12691 6.85912 6.4689L6.23558 0.649295C6.23498 0.306311 6.4344 0.1506 6.70673 0H10.7617H10.762Z",
    fill: "#62C776"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 11.8426V11.4491C0.138697 11.0625 0.417578 10.7574 0.838132 10.7012L16.5924 10.6997C17.7517 10.8467 17.7549 12.4384 16.5924 12.5917L0.838132 12.5902C0.417876 12.534 0.138697 12.2289 0 11.8423V11.8426Z",
    fill: "#62C776"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstallersIconGreen);
export default __webpack_public_path__ + "static/media/installersIconGreen.62eac40a0657452e1e0f27dc3418acd0.svg";
export { ForwardRef as ReactComponent };